import styled from 'styled-components';
import { Typ40 } from 'dc/Typ';

export const PageWrapper = styled.div`
  width: 288px;
  margin: 32px 80px 33px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: relative;
`;

export const Title = styled(Typ40)`
  color: #263238;
  text-align: left;
  width: 100%;
  margin-bottom: 8px;
`;
